import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Slideshow = ({ slides, intervalMs = 5000, ariaLabel = "Parish photo slideshow" }) => {
    const [i, setI] = useState(0);

    useEffect(() => {
        if (!slides?.length) return;
        const t = setInterval(() => setI((p) => (p + 1) % slides.length), intervalMs);
        return () => clearInterval(t);
    }, [slides, intervalMs]);

    if (!slides?.length) return null;

    const go = (dir) => setI((p) => (p + dir + slides.length) % slides.length);

    return (
        <div className="relative overflow-hidden rounded-2xl border border-maroon-100 bg-maroon-900/5 shadow-md" aria-roledescription="carousel" aria-label={ariaLabel} data-testid="about-slideshow">
            <div className="aspect-[16/9] relative">
                {slides.map((s, idx) => (
                    <img
                        key={s.src}
                        src={s.src}
                        alt={s.alt}
                        className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ease-out ${
                            idx === i ? "opacity-100" : "opacity-0"
                        }`}
                        loading={idx === 0 ? "eager" : "lazy"}
                        decoding="async"
                        width={1600}
                        height={900}
                    />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-maroon-900/45 via-transparent to-transparent pointer-events-none" />
                <div className="absolute bottom-3 right-4 flex items-center gap-1">
                        <button
                            type="button"
                            onClick={() => go(-1)}
                            aria-label="Previous slide"
                            data-testid="slideshow-prev"
                            className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-cream-50/80 text-maroon-800 hover:bg-cream-50 backdrop-blur"
                        >
                            <ChevronLeft size={18} />
                        </button>
                        <button
                            type="button"
                            onClick={() => go(1)}
                            aria-label="Next slide"
                            data-testid="slideshow-next"
                            className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-cream-50/80 text-maroon-800 hover:bg-cream-50 backdrop-blur"
                        >
                            <ChevronRight size={18} />
                        </button>
                </div>
            </div>
            <div className="flex items-center justify-center gap-1.5 py-3 bg-cream-50/70">
                {slides.map((_, idx) => (
                    <button
                        key={idx}
                        type="button"
                        onClick={() => setI(idx)}
                        aria-label={`Go to slide ${idx + 1}`}
                        data-testid={`slideshow-dot-${idx}`}
                        className={`h-1.5 rounded-full transition-all ${
                            idx === i ? "w-7 bg-maroon-600" : "w-2 bg-maroon-300/60 hover:bg-maroon-400"
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Slideshow;
